import React, { useEffect, useState } from "react";
import { Layout, Menu, Drawer, Button, Grid } from "antd";
import {
  UserOutlined,
  MenuOutlined,
  AppstoreAddOutlined,
  PlaySquareOutlined,
  EnvironmentOutlined,
  FundProjectionScreenOutlined,
  UsergroupAddOutlined,
  GlobalOutlined,
  ClockCircleOutlined,
  DesktopOutlined,
  DashboardOutlined,
  BookOutlined,
  CloudDownloadOutlined,
  AuditOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

const { Sider, Header } = Layout;
const { useBreakpoint } = Grid;

const AppSidebar = () => {
  const screens = useBreakpoint();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [userPermissions, setUserPermissions] = useState({});

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    setUserPermissions(userData.permissions || {});
  }, []);

  const menuItems = [
    {
      key: "home",
      label: "Home",
      permissions: [
        "locations.view",
        "users.view",
        "roles.view",
        "cities.view",
      ],
      type: "group",
    },
    {
      key: "dashboard",
      icon: <DashboardOutlined />,
      permissions: [
        "signage.media_view",
        "signage.playlist_view",
        "signage.screens_view"
      ],
      label: "Dashboard",
    },
    {
      key: "masters",
      label: "Masters",
      permissions: [
        "locations.view",
        "users.view",
        "roles.view",
        "cities.view",
      ],
      type: "group",
    },
    {
      key: "roles",
      icon: <UsergroupAddOutlined />,
      permissions: ["roles.view"],
      label: "Roles",
    },
    {
      key: "users",
      icon: <UserOutlined />,
      permissions: ["users.view"],
      label: "Users",
    },
    {
      key: "cities",
      icon: <GlobalOutlined />,
      permissions: ["cities.view"],
      label: "Cities",
    },
    {
      key: "locations",
      icon: <EnvironmentOutlined />,
      permissions: ["locations.view"],
      label: "Locations",
    },
    {
      key: "app",
      label: "App",
      permissions: [
        "signage.media_view",
        "signage.playlist_view",
        "signage.screens_view",
      ],
      type: "group",
    },
    {
      key: "library",
      icon: <AppstoreAddOutlined />,
      permissions: ["signage.media_view"],
      label: "Media Library",
    },
    {
      key: "playlists",
      icon: <PlaySquareOutlined />,
      permissions: ["signage.playlist_view"],
      label: "Playlists",
    },
    {
      key: "screens",
      icon: <FundProjectionScreenOutlined />,
      permissions: ["signage.screens_view"],
      label: "Screens",
    },
    {
      key: "schedules",
      icon: <ClockCircleOutlined />,
      permissions: ["signage.schedule_view"],
      label: "Schedules",
    },
    {
      key: "devices",
      icon: <DesktopOutlined />,
      permissions: ["signage.screens_view"],
      label: "Devices",
    },
    {
      key: "logs",
      icon: <BookOutlined />,
      permissions: [
        "cities.view",
        "locations.view",
        "roles.create",
        "roles.delete",
        "roles.edit",
        "roles.view",
        "signage.media_approve",
        "signage.media_create",
        "signage.media_delete",
        "signage.media_edit",
        "signage.media_view",
        "signage.playlist_approve",
        "signage.playlist_create",
        "signage.playlist_delete",
        "signage.playlist_edit",
        "signage.playlist_view",
        "signage.schedule_create",
        "signage.schedule_delete",
        "signage.schedule_edit",
        "signage.schedule_view",
        "signage.screens_create",
        "signage.screens_delete",
        "signage.screens_edit",
        "signage.screens_view",
        "signage.view",
        "users.delete",
        "users.edit",
        "users.view"],
      label: "Logs",
    },
    {
      key: "app-update",
      icon: <CloudDownloadOutlined />,
      permissions: [
        "cities.view",
        "locations.view",
        "roles.create",
        "roles.delete",
        "roles.edit",
        "roles.view",
        "signage.media_approve",
        "signage.media_create",
        "signage.media_delete",
        "signage.media_edit",
        "signage.media_view",
        "signage.playlist_approve",
        "signage.playlist_create",
        "signage.playlist_delete",
        "signage.playlist_edit",
        "signage.playlist_view",
        "signage.schedule_create",
        "signage.schedule_delete",
        "signage.schedule_edit",
        "signage.schedule_view",
        "signage.screens_create",
        "signage.screens_delete",
        "signage.screens_edit",
        "signage.screens_view",
        "signage.view",
        "users.delete",
        "users.edit",
        "users.view",
      ],
      label: "App Updates",
    },
    {
      key: "meeting-room-devices",
      icon: <AuditOutlined />,
      permissions: ["signage.meeting_room_view"],
      label: "Meeting Room Devices",
    },
    {
      key: "meeting-room-apk",
      icon: <AuditOutlined />,
      permissions: ["signage.meeting_room_view"],
      label: "Meeting Room Apk",
    }
  ];

  const handleMenuClick = ({ key }) => {
    navigate(`/${key}`);
    setDrawerVisible(false);
  };

  const filteredMenuItems = menuItems.filter((item) => {
    return (
      !item.permissions ||
      item.permissions.some((perm) => userPermissions[perm] === "1")
    );
  });

  const menu = (
    <Menu
      mode="inline"
      selectedKeys={[location.pathname.split("/")[1]]}
      items={filteredMenuItems}
      onClick={handleMenuClick}
    />
  );

  return !screens.md ? (
    <>
      <Header style={{ padding: "0 1rem" }} className="bg-light">
        <Button
          icon={<MenuOutlined />}
          onClick={() => setDrawerVisible(true)}
        />
      </Header>
      <Drawer
        title="Menu"
        placement="left"
        open={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        styles={{ body: { padding: 0 } }}
      >
        {menu}
      </Drawer>
    </>
  ) : (
    <Sider width={200} className="site-layout-background bg-white">
      {menu}
    </Sider>
  );
};

export default AppSidebar;
